import type { KycRowError } from "./kyc";

export function getKycError(error: unknown): {
  message: string;
  errors: KycRowError[];
} {
  const fallback = {
    message: "Unable to submit. Refresh inventory before trying again.",
    errors: [],
  };
  if (!error || typeof error !== "object" || !("data" in error)) {
    return fallback;
  }
  const data = error.data;
  if (!data || typeof data !== "object") {
    return fallback;
  }
  return {
    message:
      "message" in data && typeof data.message === "string"
        ? data.message
        : fallback.message,
    errors:
      "errors" in data && Array.isArray(data.errors)
        ? data.errors.filter(
            (row): row is KycRowError =>
              row !== null &&
              typeof row === "object" &&
              typeof row.row === "number" &&
              typeof row.iccid === "string" &&
              typeof row.message === "string",
          )
        : [],
  };
}
